import Player from '@vimeo/player/dist/player';
import BlockCover from '../plugins/BlockCover';

export default function initVideoHero() {
  Alpine.data('videoHero', () => ({
    playing: false,
    init() {
      const previewIframe = document.getElementById('preview-video');
      if (previewIframe) {
        const previewVideo = new Player(previewIframe);
        // pause video if out of screen
        previewVideo.ready().then(() => {
          this.observePosition(previewVideo);
        });
      }
    },
    showMainVideo() {
      const mainIframe = document.getElementById('main-video');
      const previewIframe = document.getElementById('preview-video');
      const container = document.getElementById('video-hero');
      if (mainIframe && previewIframe && container) {
        const video = new Player(mainIframe);
        const previewVideo = new Player(previewIframe);
        const self = this;
        video.on('pause', () => {
          self.playing = false;
          // pause/start video if out of screen
          this.observePosition(previewVideo);
          container.style.removeProperty('height');
          // exit fullscreen if in fullscreen
          if (document.fullscreenElement) {
            if (document.exitFullscreen) {
              document.exitFullscreen();
            } else if (document.webkitExitFullscreen) { /* Safari */
              document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) { /* IE11 */
              document.msExitFullscreen();
            }
          }
        });
        video.play();
        self.playing = true;
        video.ready().then(() => {
          if (self.playing) {
            self.observePosition(video);
          }
          // force fullscreen for mobile devices
          if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
            if (mainIframe.requestFullscreen) {
              mainIframe.requestFullscreen();
            } else if (mainIframe.webkitRequestFullscreen) { /* Safari */
              mainIframe.webkitRequestFullscreen();
            } else if (mainIframe.msRequestFullscreen) { /* IE11 */
              mainIframe.msRequestFullscreen();
            }
          }
        });
        previewVideo.pause();
        container.style.height = `${mainIframe.clientHeight}px`;
      }
    },
    positionVideo(iframeId: string) {
      const video = document.getElementById(iframeId);
      if (video !== null) {
        /* eslint-disable no-new */
        new BlockCover(video);
      }
    },
    observePosition(video: any) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            video.getPaused().then((paused: any) => {
              if (!entry.isIntersecting && !paused) {
                video.pause();
              } else if (
                entry.isIntersecting
                && paused
                && video.element.id !== 'main-video'
                && !this.playing
              ) {
                video.play();
              }
            });
          });
        },
        { threshold: 0.1 },
      );
      observer.observe(video.element);
    },
  }));
}
